export type SortDir = "asc" | "desc";

export function sortItemsByText<T extends { text: string }>(
  items: T[],
  dir: SortDir
): T[] {
  const factor = dir === "asc" ? 1 : -1;
  return items
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const cmp = a.item.text.localeCompare(b.item.text, undefined, {
        sensitivity: "base",
      });
      if (cmp !== 0) return cmp * factor;
      return a.index - b.index;
    })
    .map((row) => row.item);
}
